import { render, staticRenderFns } from "./newsDet.vue?vue&type=template&id=205dea32&scoped=true&"
import script from "./newsDet.vue?vue&type=script&lang=js&"
export * from "./newsDet.vue?vue&type=script&lang=js&"
import style0 from "./newsDet.vue?vue&type=style&index=0&id=205dea32&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205dea32",
  null
  
)

export default component.exports